import { all, call, takeLatest, put, select } from "redux-saga/effects";
import {
  suggestionsError,
  suggestionsRequested,
  suggestionsSuccess,
} from "actions";
import { SUGGESTIONS_REQUEST } from "actions/const";
import { fetchSuggestions as fetch } from "services/search/product";
import * as selectors from "./selectors";

export function* fetchSuggestions(action) {
  const term = action.term;
  const limit = yield select(selectors.getMaxSuggestions);

  if (!term) {
    yield put(suggestionsSuccess([]));
    return;
  }

  yield put(suggestionsRequested());

  try {
    const suggestions = yield call(fetch, term, limit);

    yield put(suggestionsSuccess(suggestions));
  } catch {
    yield put(suggestionsError());
  }
}

// watcher
export function* watchSuggestions() {
  yield all([yield takeLatest(SUGGESTIONS_REQUEST, fetchSuggestions)]);
}
